module.exports = __webpack_public_path__ + "charOvershootRotateIn.gif";